import React from 'react';
import showEyeIcon from '../icons/showEyeIcon.svg';
import hideEyeIcon from '../icons/hideEyeIcon.svg';

const ShowHistoryButton = ({ show, onClick }) => {
  return (
    <a className="flex" onClick={onClick}>
      <p>{show ? 'Hide Audit Log' : 'Show Audit Log'}</p>
      <img className="ml-1" src={show ? hideEyeIcon : showEyeIcon} />
    </a>
  );
};

export default ShowHistoryButton;
